import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class LogoutPage extends Component {
    
    render () {
        localStorage.removeItem('authToken');
        localStorage.removeItem('is_new');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userType');
        localStorage.removeItem('bill_npi');
        localStorage.removeItem('userID')
        return (
            <Redirect to="/login"/>
        )
    }
}

export default LogoutPage


// WEBPACK FOOTER //
// ./src/app/logout_page/LogoutPage.js